import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { Button } from "./ui/button";
import "./styles.css";

class ErrorBoundary extends React.Component<React.PropsWithChildren, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <main className="next-login flex items-center justify-center"><div className="w-full max-w-sm"><p className="font-semibold tracking-widest">ESTET BAGS</p><h1 className="text-xl font-semibold mt-6">Не удалось открыть интерфейс</h1><p className="text-sm text-muted-foreground mt-3 leading-6">Обновите страницу, чтобы попробовать снова.</p><Button className="w-full mt-6" onClick={() => location.reload()}>Обновить страницу</Button></div></main>;
    return this.props.children;
  }
}
const client = new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false, staleTime: 30_000 } } });
ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><ErrorBoundary><QueryClientProvider client={client}><App /></QueryClientProvider></ErrorBoundary></React.StrictMode>);
